import React from 'react';
import './style.css';
import Box from 'components/UI/Box';
const DialogueOverlay = props => (
  <div className="div__DialogueOverlay">
    <Box outline> {props.children} </Box>
  </div>
);

export default DialogueOverlay;
